<div class="row narrow-gutters">
  <div class="col-md-auto ms-auto">
    <span class="dropdown mx-1">
      <button class="btn btn-outline-secondary dropdown-toggle" style="min-width: 10rem" type="button"
              data-bs-toggle="dropdown">Messages
        <span class="caret"></span></button>
        <ul class="dropdown-menu dropdown-menu-start">
          @for (list of lists; track list) {
            @for (declaration of getDeclarations(list); track declaration) {
              @if (declaration.type === 'COPRAR') {
                <li (click)="openMessages(declaration)"
                    class="dropdown-item">{{ declaration.type }} to terminal code {{ declaration.id }}
                  at {{ declaration.timeStamp | date: "dd-MM-yyyy HH:mm" }}</li>
              }
            }
          }
        </ul>
      </span>
  </div>
</div>
